import Form                from "@/utils/forms/form";
import baseField           from "@/utils/forms/fields/baseField";
import { ValidationError } from "@/utils/forms/exceptions";
import { isNumeric }       from "@/utils/forms/validators";
import BaseForm            from "@/utils/BaseForm";
import t                   from "@/i18n/translator";

class RepayFormValidator extends Form {
    constructor(data) {
        super(data);
        this.dateofbirth = new baseField({
            label: "Birthday",
            required: true,
            zeroValues: [null, ""]
        });
        this.account = new baseField({
            label: "Account",
            required: true,
            validators: [
                isNumeric,
                val => {
                    if (val && (val < 10 || val > 99999)) {
                        throw new ValidationError(t("client_account"));
                    }
                }
            ],
            zeroValues: [""]
        });
    }
}

export class RepayForm extends BaseForm {
    constructor(account, dateofbirth) {
        super(RepayFormValidator);
        this.dateofbirth = dateofbirth || null;
        this.account = account || "";
    }

    setBirthday(e) {
        const val = e.target.value;
        if (new Date().getFullYear() - val.getFullYear() < 18) {
            e.target.value = this.dateofbirth;
            return;
        }
        this.dateofbirth = val;
    }

    setAccount(e) {
        const val = e.target.value;
        if ((val.length > 0 && !/^\d+$/g.test(val)) || val.length > 5) {
            e.target.value = this.account;
            return;
        }
        this.account = Number(val);
    }

    static dateToJSON(d) {
        const month = "0"+(d.getMonth() + 1);
        const day = "0"+d.getDate();
        return `${day.substr(-2)}/${month.substr(-2)}/${d.getFullYear()}`
    }
    serialize() {
        const form = super.serialize();
        form.dateofbirth = RepayForm.dateToJSON(this.dateofbirth);
        return form
    }
}


class AmountFormValidator extends Form {
    constructor(data) {
        super(data);
        this.amount = new baseField({
            label: "Repay amount",
            validators: [
                isNumeric,
                val => {
                    if (val && !(Number(val) >= 36 && Number(val) <= 1000000)) {
                        throw new ValidationError(t("repay_amount"));
                    }
                }
            ],
            zeroValues: [""]
        });
    }
}

export class AmountForm extends BaseForm {
    constructor(val) {
        super(AmountFormValidator);
        this.amount = val ? val.toString() : "";
    }

    setAmount(e) {
        const val = e.target.value;
        if ((val.length > 0 && !/^\d+$/g.test(val)) || val.length > 6) {
            e.target.value = this.amount;
            return;
        }
        this.amount = val;
    }
}
